export default {
  
  en: {
    title: 'Customer Management',
    customerList: 'Customer List',
    customerDetail: 'Customer Detail',
    mobile: 'Phone number',
    names: 'name',
    surnames: 'surname',
    curpType: 'curpType',
    curp: 'curp',
    appName: 'App Name',
    custName: 'cust name',
    AadhaarName: 'Aadhaar Name',
    AadhaarAddress: 'Aadhaar Address',
    AadhaarYears: 'Aadhaar Years',
    AadhaarDate: 'Aadhaar Date',
    AadhaarNo: 'Aadhaar Number',
    panName: 'Pan Name',
    panNo: 'Pan Number',
    email: 'Email',
    panAddress: 'Pan Address',
    panYears: 'Pan Years',
    panDate: 'Pan Date',
    bankAccountName: 'BankAccount Name',
    bankAccountNo: "User's current updated receiving account",
    collectType: 'collect type',
    ifscCode: 'IFSC CODE',
    maritalStatus: 'Marital Status',
    spouseName: 'Spouse Name',
    educationLevel: 'Education Level',
    monthlyHouseholdIncome: 'Monthly Household Income',
    personalMonthlyIncome: 'Personal Monthly Income',
    housingType: 'Housing Type',
    residentialAddress: 'Dirección de residencia',
    residentialAddressPIN: 'Residential Address PIN',
    workType: 'Work Type',
    workingAddress: 'Working Address',
    workingAddressPIN: 'Working Address PIN',
    companyName: 'Company Name',
    workIndustry: 'Work Industry',
    workDuty: 'Work Duty',
    workPosition: 'Work Position',
    workYear: 'Work Year',
    payMethod: 'Pay Method',

    contactType: 'Type',
    contactRelationship: 'Relationship',
    contactName: 'Contact name',
    contactPhone: 'Phone number',
    firstContact: 'First Contact',
    secondContact: 'Second Contact',

    aadhaarFront: 'Aadhaar Front',
    aadhaarBack: 'Aadhaar Back',
    panFront: 'PAN Front',
    facePhotoList: 'Face Photo',

    createTime: 'Fecha de creación',
    reborrowFlag: 'Reborrow Flag',
    customerBasicInfo: 'Customers Basic Information',
    customerDetailInfo: 'Customers Detail Information',
    customerLinkInfo: 'Customers Contact Information',
    customerAadhaarInfo: 'Customers Aadhaar\'s OCR Information',
    customerPanInfo: 'Customers Pan\'s OCR Information',
    customerImageInfo: 'Customer Image Data',
    age: 'Edad',
    channel: 'Channel',
    productName: 'Product Name',
    epochScore: 'Epoch Score',
    modelScore: 'Model Score',
    customerRiskInfo: 'Customer Risk Info',
    panCardLiveScore: 'PAN CARD FACE SCORE',
    aadhaarCardLiveScore: 'AADHAAR FACE SCORE',

    stpAccount: 'stp',
    fullName: 'Full name',
    bankName: 'Bank Name',
    excelList: ' Download loan information images ',
    orderImages: 'Up payment voucher ',

    companyPhone: 'Company Office Number',
    monthlyIncomeScope: 'monthly income',
    description: 'description',
  },
  es: {
    title: 'Quản lý khách hàng',
    customerList: 'Danh sách khách hàng',
    customerDetail: 'Chi tiết khách hàng',
    mobile: 'Số điện thoại',
    names: 'Họ tên',
    surnames: 'Họ',
    curpType: 'Loại giấy tờ',
    curp: 'Giấy tờ',
    appName: 'Tên ứng dụng',
    email: 'Email',
    description: 'Mô tả',
    custName: 'Tên khách hàng',
    AadhaarName: 'Tên Aadhaar',
    AadhaarAddress: 'Địa chỉ Aadhaar',
    AadhaarYears: 'Năm Aadhaar',
    AadhaarDate: 'Ngày Aadhaar',
    AadhaarNo: 'Số Aadhaar',
    panName: 'Tên Pan',
    panNo: 'Số thẻ Pan',
    panAddress: 'Địa chỉ Pan',
    panYears: 'Năm Pan',
    panDate: 'Ngày Pan',
    bankAccountName: 'Tên tài khoản ngân hàng',
    bankAccountNo: 'Tài khoản nhận tiền mới nhất của người dùng',
    collectType: 'Phương thức nhận tiền',
    ifscCode: 'Mã IFSC',
    maritalStatus: 'Tình trạng hôn nhân',
    spouseName: 'Tên vợ/chồng',
    educationLevel: 'Trình độ học vấn',
    monthlyHouseholdIncome: 'Thu nhập hộ gia đình hàng tháng',
    personalMonthlyIncome: 'Thu nhập cá nhân hàng tháng',
    housingType: 'Loại nhà ở',
    residentialAddress: 'Địa chỉ cư trú',
    residentialAddressPIN: 'Mã PIN địa chỉ cư trú',
    workType: 'Loại hình công việc',
    workingAddress: 'Địa chỉ nơi làm việc',
    workingAddressPIN: 'Mã PIN địa chỉ nơi làm việc',
    companyName: 'Tên công ty',
    workIndustry: 'Ngành nghề',
    workDuty: 'Chức vụ',
    workPosition: 'Vị trí công việc',
    workYear: 'Số năm làm việc',
    payMethod: 'Hình thức trả lương',

    contactType: 'Loại liên hệ',
    contactRelationship: 'Mối quan hệ',
    contactName: 'Tên người liên hệ',
    contactPhone: 'Số điện thoại người liên hệ',
    firstContact: 'Người liên hệ thứ nhất',
    secondContact: 'Người liên hệ thứ hai',

    aadhaarFront: 'Mặt trước thẻ Aadhaar',
    aadhaarBack: 'Mặt sau thẻ Aadhaar',
    panFront: 'Ảnh thẻ PAN',
    facePhotoList: 'Ảnh nhận diện khuôn mặt',

    createTime: 'Thời gian đăng ký',
    reborrowFlag: 'Dấu hiệu vay lại',
    customerBasicInfo: 'Thông tin cơ bản khách hàng',
    customerDetailInfo: 'Thông tin chi tiết khách hàng',
    customerLinkInfo: 'Thông tin liên hệ khách hàng',
    customerAadhaarInfo: 'Thông tin OCR thẻ Aadhaar',
    customerPanInfo: 'Thông tin OCR thẻ Pan',
    customerImageInfo: 'Dữ liệu hình ảnh khách hàng',
    age: 'Tuổi',
    channel: 'Kênh',
    productName: 'Tên sản phẩm',
    epochScore: 'Điểm Epoch',
    modelScore: 'Điểm Model',
    customerRiskInfo: 'Thông tin rủi ro khách hàng',
    panCardLiveScore: 'Điểm tương đồng khuôn mặt thẻ PAN',
    aadhaarCardLiveScore: 'Điểm tương đồng khuôn mặt thẻ Aadhaar',

    payoutId: 'ID kênh giải ngân',
    stpAccount: 'Tài khoản STP',
    fullName: 'Họ tên đầy đủ',
    bankName: 'Tên ngân hàng nhận',
    excelList: 'Tải xuống hình ảnh thông tin khoản vay',
    orderImages: 'Chứng từ thanh toán',

    companyPhone: 'Số điện thoại công ty',
    monthlyIncomeScope: 'Thu nhập hàng tháng',
    description: 'Mô tả',
  },
}
